/* eslint-disable import/no-cycle */
import Api from '@/api';

const theState = {
    loading: false,
    email: '',
    firstname: '',
    lastname: '',
    salutation: '',
    skipMailing: false,
};

const actions = {
    linkAccounts({ commit, dispatch, state }, data) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);

            let linkedAccountData = {
                orderId: data.orderId,
                email: state.email,
                gender: state.salutation,
                firstName: state.firstname,
                lastName: state.lastname,
                skipMailing: state.skipMailing,
            };

            if (data.position) {
                linkedAccountData.position = data.position;
            }

            Api.customer.createLinkedAccount(data.ssoId, linkedAccountData)
                .then(() => {
                    commit('hideDialog');
                    dispatch('customerLinkedAccounts/getLinkedAccounts', data.ssoId, { root: true });
                    dispatch('customerLinkedAccounts/getLinkedAccountsSummary', data.ssoId, { root: true });
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        });
    },
};

const mutations = {
    resetState(state) {
        state.loading = false;
        state.email = '';
        state.firstname = '';
        state.lastname = '';
        state.salutation = '';
        state.skipMailing = false;
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    setEmail(state, email) {
        state.email = email;
    },

    setSkipMailing(state, value) {
        state.skipMailing = value == 'on';
    },

    setFirstname(state, firstname) {
        state.firstname = firstname;
    },

    setLastname(state, lastname) {
        state.lastname = lastname;
    },

    setSalutation(state, salutation) {
        state.salutation = salutation;
    },
};

export default {
    namespaced: true,
    state: theState,
    actions,
    mutations,
};
